import { render, staticRenderFns } from "./ContainerFrame.vue?vue&type=template&id=412a6674&scoped=true"
import script from "./ContainerFrame.vue?vue&type=script&lang=ts"
export * from "./ContainerFrame.vue?vue&type=script&lang=ts"
import style0 from "./ContainerFrame.vue?vue&type=style&index=0&id=412a6674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a6674",
  null
  
)

export default component.exports